import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Box,
  Typography,
} from '@mui/material'

const ExportColumnsDialog = ({ open, onClose, columns, onConfirm, loading }) => {
  const [selectedKeys, setSelectedKeys] = useState([])

  // Initialize selected keys with all column keys when the dialog opens
  useEffect(() => {
    if (open) {
      setSelectedKeys(columns.map((col) => col.key))
    }
  }, [open, columns])

  const handleToggleColumn = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    )
  }

  const handleSelectAll = () => {
    if (selectedKeys.length === columns.length) {
      setSelectedKeys([])
    } else {
      setSelectedKeys(columns.map((col) => col.key))
    }
  }

  const handleConfirm = () => {
    onConfirm(selectedKeys)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Columns to Export</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedKeys.length === columns.length}
                indeterminate={
                  selectedKeys.length > 0 && selectedKeys.length < columns.length
                }
                onChange={handleSelectAll}
              />
            }
            label={
              <Typography fontWeight={600}>
                {selectedKeys.length === columns.length ? 'Deselect All' : 'Select All'}
              </Typography>
            }
          />
        </Box>
        <FormGroup sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
          {columns.map((col) => (
            <FormControlLabel
              key={col.key}
              control={
                <Checkbox
                  checked={selectedKeys.includes(col.key)}
                  onChange={() => handleToggleColumn(col.key)}
                  size="small"
                />
              }
              label={<Typography variant="body2">{col.label}</Typography>}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={selectedKeys.length === 0 || loading}
        >
          {loading ? 'Exporting...' : 'Export'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportColumnsDialog
